import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { schoolResponses } from "@/mocks/homeData";

export default function SchoolResponses() {
  return (
    <section id="responses" className="w-full border-y border-foreground-900/10 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-24">
        <Reveal>
          <SectionHeading
            index="03"
            eyebrow="School Response"
            title="学校回应原文摘录"
            desc="学校回应是判断一起校园事件走向的关键。以下文字均来自校方公开说明的摘录，保留原意，不添加评论。"
          />
        </Reveal>

        <div className="mt-10 flex flex-col md:mt-14">
          {schoolResponses.map((item, index) => (
            <Reveal key={item.school} delay={index * 90}>
              <blockquote className="grid gap-5 border-t border-foreground-900/10 py-8 md:grid-cols-12 md:gap-8 md:py-10">
                <div className="md:col-span-4">
                  <p className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {item.school}
                  </p>
                  <p className="mt-2 text-xs text-foreground-500">{item.date}</p>
                  <span
                    className={[
                      "mt-3 inline-block rounded-full px-3 py-1 text-[11px]",
                      item.status === "已公开"
                        ? "bg-secondary-100 text-secondary-900"
                        : "bg-primary-100 text-primary-900",
                    ].join(" ")}
                  >
                    {item.status}
                  </span>
                </div>
                <div className="md:col-span-8">
                  <span className="flex h-8 w-8 items-center justify-start text-accent-400">
                    <i className="ri-double-quotes-l text-3xl" />
                  </span>
                  <p className="mt-1 font-heading text-lg font-medium leading-loose text-foreground-800 md:text-2xl md:leading-[1.75]">
                    {item.quote}
                  </p>
                </div>
              </blockquote>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}